export default __webpack_public_path__ + "static/media/Gloves of the Death God.dc4e9e01.jpg";